import {
  pgTable,
  text,
  serial,
  timestamp,
  varchar,
  jsonb,
  index,
} from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod";

export const auditLogs = pgTable(
  "audit_logs",
  {
    id: serial("id").primaryKey(),
    timestamp: timestamp("timestamp").defaultNow().notNull(),
    adminUserId: varchar("admin_user_id"),
    action: varchar("action", { length: 255 }).notNull(),
    entityType: varchar("entity_type", { length: 100 }),
    entityId: varchar("entity_id", { length: 255 }),
    before: jsonb("before"),
    after: jsonb("after"),
    metadata: jsonb("metadata"),
    ipAddress: varchar("ip_address", { length: 45 }),
    userAgent: text("user_agent"),
  },
  (table) => ({
    timestampIndex: index("idx_audit_logs_timestamp").on(table.timestamp),
    adminUserIndex: index("idx_audit_logs_admin_user").on(table.adminUserId),
    actionIndex: index("idx_audit_logs_action").on(table.action),
    entityIndex: index("idx_audit_logs_entity").on(
      table.entityType,
      table.entityId
    ),
  })
);

export const insertAuditLogSchema = createInsertSchema(auditLogs).omit({
  id: true,
});

export type AuditLog = typeof auditLogs.$inferSelect;
export type InsertAuditLog = z.infer<typeof insertAuditLogSchema>;
